module.exports = __webpack_public_path__ + "img/9.07ed9d93.jpg";